/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IImageCardData } from './image-card.data';
import { IImageCardProps } from './image-card.props.autogenerated';

export interface IImageCardViewProps extends IImageCardProps<IImageCardData> {}

/**
 *
 * ImageCard component
 * @extends {React.PureComponent<IImageCardProps<IImageCardData>>}
 */
class ImageCard extends React.PureComponent<IImageCardProps<IImageCardData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default ImageCard;
